var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-pet-map-box"},[_c('el-carousel',{attrs:{"autoplay":false,"height":_vm.height}},_vm._l((_vm.mapDatas),function(datas,mapID){return _c('el-carousel-item',{key:mapID},[_c('jx3box-map',{attrs:{"mapId":Number(mapID),"datas":datas},on:{"resize":_vm.handleResize}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }